import React from "react";
import { createRoot } from "react-dom/client";
import WalletApp from "./components/WalletApp";
import ConnectButton from "./components/ConnectButton";
import CollectionSetup from "./components/CollectionSetup";
import DeployLyre from "./components/DeployLyre";
import ManageSubnames from "./components/ManageSubnames";

const COMPONENTS = {
  ConnectButton,
  CollectionSetup,
  DeployLyre,
  ManageSubnames,
};

const mountedRoots = new WeakSet();

function mountReactComponents() {
  const elements = document.querySelectorAll("[data-react-component]");

  elements.forEach((el) => {
    if (mountedRoots.has(el)) return;

    const componentName = el.dataset.reactComponent;
    const Component = COMPONENTS[componentName];

    if (!Component) {
      console.warn(`Unknown React component: ${componentName}`);
      return;
    }

    const props = {};
    Object.keys(el.dataset).forEach((key) => {
      if (key !== "reactComponent") {
        props[key] = el.dataset[key];
      }
    });

    try {
      const root = createRoot(el);
      root.render(
        <WalletApp>
          <Component {...props} />
        </WalletApp>
      );
      mountedRoots.add(el);
    } catch (err) {
      console.error(`Failed to mount ${componentName}:`, err);
    }
  });
}

// Mount immediately if DOM is already loaded, otherwise wait
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountReactComponents);
} else {
  mountReactComponents();
}

// Re-mount on Turbo navigations
document.addEventListener("turbo:load", mountReactComponents);
